import { ActionType } from 'typesafe-actions';
import BaseReducer, {
	baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as shoppingCenterGroupedActions from './shoppingCentersGroupedActions';
import { IShoppingCenterGroupedType } from '../../types/IShoppingCenterGroupedType';

export type ShoppingCenterGroupedAction = ActionType<typeof shoppingCenterGroupedActions>;

export interface IShoppingCenterGroupedStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IShoppingCenterGroupedType };
	readonly queries: { [queryKey: string]: IShoppingCenterGroupedType[] };
}

export function shoppingCenterGroupedReducer(
	state = baseInitialState as IShoppingCenterGroupedStateType,
	action: ShoppingCenterGroupedAction,
) {
	const Reducer = new BaseReducer('shoppingCenterGroupedReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			default:
				return innerState;
		}
	});
}
